export default __webpack_public_path__ + "static/media/Gfgc.1ec37147.png";